import { render, staticRenderFns } from "./des_kel.vue?vue&type=template&id=8203a2b0&"
import script from "./des_kel.vue?vue&type=script&lang=js&"
export * from "./des_kel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports